require('./customerFinderView.scss');

// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const PureRenderMixin = require('react-addons-pure-render-mixin');
const classNames = require('classnames');

// @ commons
const { formatText } = require('core/i18n').i18n;
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKCover } = require('commonsComponents/OKCover');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');

// @ constants
const {
    FIRST_STEP,
    SECOND_STEP,
    THIRD_STEP,
    WIZARD_FIRST_STEP,
    WIZARD_SECOND_STEP,
    WIZARD_THIRD_STEP
} = require('constants/index');
const {
    TRANSLATION_PLATFORM_PRI,
    TRANSLATION_PLATFORM_CC
} = require('constants/translations');

//@ components
const StepClientSearch = require('components/contactCenter/disasterRecovery/steps/stepClientSearch/stepClientSearch');
const StepValidateInteractionId = require('components/contactCenter/disasterRecovery/steps/stepValidateInteractionId/stepValidateInteractionId');
const StepClientLogin = require('components/contactCenter/disasterRecovery/steps/stepClientLogin/stepClientLogin');
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');
const TopBarCC = require('components/contactCenter/navbarCC/topBarCC');

//@utilities
const { isInOffice } = require('utilities/contactCenter/disasterRecoveryhelper');

const { getLanguage } = require('core/i18n').i18n;

class CustomerFinderView extends React.Component {
    constructor(props) {
        super(props);
        this.shouldComponentUpdate = PureRenderMixin.shouldComponentUpdate.bind(this);
        this.handleEndInteraction = this.handleEndInteraction.bind(this);
        this.onHandleGoBack = this.onHandleGoBack.bind(this);
        this.state = {
            resetCounter: 0
        };
    }

    componentDidMount() {
        const {
            endInteraction,
            history,
            immDisasterRecoveryAgentTokenRenewal,
            startAgentTokenRenewalTimer
        } = this.props;
        if (!this.isInteractionIdOff()) {
            endInteraction()
        }
        const agentTokenRenewalTimer = immDisasterRecoveryAgentTokenRenewal.get('timer');
        if (!agentTokenRenewalTimer) {
            startAgentTokenRenewalTimer(history);
        }
    }

    isInteractionIdOff() {
        return this.props.immLogin
            && this.props.immLogin.get('sessionExpired') === true
            && this.props.immLogin.get('isAuthenticated') === false
            && this.props.immLogin.get('isAuthenticating') === false
    }

    getTranslations() {
        const { requestTranslations } = this.props;
        requestTranslations(__CONTACT_CENTER__ ? TRANSLATION_PLATFORM_CC : TRANSLATION_PLATFORM_PRI, getLanguage());
    }

    handleEndInteraction() {
        this.setState({ resetCounter: this.state.resetCounter + 1 });
        this.props.endInteraction();
    }

    onHandleGoBack() {
        this.setState({ resetCounter: 0 });
        this.props.endInteraction();
    }

    getClassNamesStep(step) {
        const { immCustomerFinder } = this.props;
        const visibleStep = immCustomerFinder.get('visibleStep');
        const stepClasses = classNames('customer-finder__step-container',
            { 'customer-finder__step-container--disabled': visibleStep != step }
        );

        return stepClasses;
    }

    buildErrorMessage() {
        const title = formatText('customerFinder-titleMessageBoxFailure');
        const subtitle = formatText('customerFinder-subtitleMessageBoxFailure');
        const textLink = formatText('customerFinder-textLinkMessageBoxFailure');

        return (
            <CustomMessageBox
                icon="icon-warning"
                title={title}
                subtitle={subtitle}
                textLink={textLink}
                goBackHandler={this.onHandleGoBack}
            />
        )
    }

    buildEndInteractionBlock() {
        const textEndInteraction = formatText('customerFinder-endInteractionText');
        return (
            <div className="customer-finder__end-interaction-block">
                <div className="customer-finder__end-interaction-button-container">
                    <div className="customer-finder__end-interaction-button">
                        <OKButton modifier="link-ghost" size="small" onClick={this.handleEndInteraction}>
                            <span className="customer-finder__end-interaction-link">{textEndInteraction}</span>
                        </OKButton>
                    </div>
                </div>
            </div>
        );
    }

    buildWizard() {
        const {
            immCustomerFinder, confirmClientSearch, validateInteractionId,
            confirmLogin, resetErrorMessage, showEmptyDocumentError,
            clearInteractionIdErrorMessage, validateInteractionIdWithAPI,
            updateInteractionId, history
        } = this.props;
        const immSteps = immCustomerFinder.get('steps');
        const immStepOne = immSteps.get(FIRST_STEP);
        const immStepTwo = immSteps.get(SECOND_STEP);
        const immStepThree = immSteps.get(THIRD_STEP);
        const stepOneClasses = this.getClassNamesStep(WIZARD_FIRST_STEP);
        const stepTwoClasses = this.getClassNamesStep(WIZARD_SECOND_STEP);
        const stepThirdClasses = this.getClassNamesStep(WIZARD_THIRD_STEP);
        const immClientIdentification = immSteps.getIn([FIRST_STEP, 'response']);
        const country = immSteps.getIn([FIRST_STEP, 'country']);
        const inOffice = isInOffice();

        const legatText = formatText('customerFinder-legalText');
        const title = !inOffice ? formatText('customerFinder-title') : formatText('customerFinder-titleInOffice');
        const interactionId = immCustomerFinder.get('interactionId');

        return (
            <div>
                <p className="customer-finder__legal">
                    {legatText}
                </p>
                <h2 className="customer-finder__title">
                    {title}
                </h2>
                <div>
                    <div className={stepOneClasses}>
                        <StepClientSearch
                            immStepSearchClient={immStepOne}
                            stepNo={WIZARD_FIRST_STEP}
                            handleNext={confirmClientSearch}
                            resetCounter={this.state.resetCounter}
                            resetErrorMessage={resetErrorMessage}
                            showEmptyDocumentError={showEmptyDocumentError}
                        />
                    </div>
                    <div className={stepTwoClasses}>
                        <StepValidateInteractionId
                            immStepValidateInteractionId={immStepTwo}
                            stepNo={WIZARD_SECOND_STEP}
                            handleNext={validateInteractionIdWithAPI}
                            resetCounter={this.state.resetCounter}
                            immClientIdentification={immClientIdentification}
                            validateInteractionId={validateInteractionId}
                            updateInteractionId={updateInteractionId}
                            clearInteractionIdErrorMessage={clearInteractionIdErrorMessage}
                            interactionId={interactionId}
                            country={country}
                        />
                    </div>
                    <div className={stepThirdClasses}>
                        <StepClientLogin
                            immStepClientLogin={immStepThree}
                            stepNo={WIZARD_THIRD_STEP}
                            resetCounter={this.state.resetCounter}
                            immClientIdentification={immClientIdentification}
                            handleFinish={(interactionId, dropdownOption, positions, values) => confirmLogin(interactionId, dropdownOption, positions, values, history)}
                            interactionId={interactionId}
                        />
                    </div>
                </div>
            </div>
        );
    }

    buildBodyContent() {
        const { immCustomerFinder } = this.props;
        const submitError = immCustomerFinder.get('unrecoverableError');
        const errorMessage = this.buildErrorMessage();
        const wizard = this.buildWizard();
        const endInteractionBlock = this.buildEndInteractionBlock();
        let content;

        if (submitError) {
            content = errorMessage;
        } else {
            content = (
                <div>
                    {wizard}
                    {endInteractionBlock}
                </div>
            );
        }

        return (
            <div>
                {content}
            </div>
        );
    }

    render() {
        const bodyContent = this.buildBodyContent();
        const { changeOfficeValidation, immAgentLogin } = this.props;
        this.getTranslations();

        return (
            <section className="customer-finder">
                <TopBarCC immAgentLogin={immAgentLogin} changeOfficeValidation={changeOfficeValidation} />
                <OKCover size="small" section="pg">
                    <OKHeaderLanding title="" />
                </OKCover>
                <div className="customer-finder__body">
                    {bodyContent}
                </div>
            </section>
        );
    }
}

CustomerFinderView.propTypes = {
    changeOfficeValidation: PropTypes.func.isRequired,
    clearInteractionIdErrorMessage: PropTypes.func.isRequired,
    clearRequest: PropTypes.func.isRequired,
    confirmClientSearch: PropTypes.func.isRequired,
    confirmLogin: PropTypes.func.isRequired,
    endInteraction: PropTypes.func.isRequired,
    history: PropTypes.object.isRequired,
    immAgentLogin: PropTypes.object.isRequired,
    immCustomerFinder: PropTypes.object.isRequired,
    immDisasterRecoveryAgentTokenRenewal: PropTypes.object.isRequired,
    immTranslations: PropTypes.object.isRequired,
    resetErrorMessage: PropTypes.func.isRequired,
    showEmptyDocumentError: PropTypes.func.isRequired,
    startAgentTokenRenewalTimer: PropTypes.func.isRequired,
    updateInteractionId: PropTypes.func.isRequired,
    validateInteractionId: PropTypes.func.isRequired,
    validateInteractionIdWithAPI: PropTypes.func.isRequired,
    requestTranslations: PropTypes.func.isRequired,
    immLogin: PropTypes.object
};

module.exports = withRouter(CustomerFinderView);
